import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../layout/Layout";
import myimage from "../../assets/myimage.png";
import "animate.css";
import useInView from "../../components/useInView"; // Import the custom hook
import { Link } from "react-router-dom";
import toro_image from "../../assets/toro_image.png";
import accuknox from "../../assets/accuknox.png";
import Star_Performer from "../../assets/Star_Performer.jpg";

function MeWork() {
  const [isHovered, setIsHovered] = useState(false);
  const { hash } = useLocation(); //to scroll to particular section of the page

  useEffect(() => {
    //to scroll to particular section of the page
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  //usage defined in useInView.jsx
  const ref1 = useRef(null);
  const ref3 = useRef(null);

  const isInView1 = useInView(ref1);
  const isInView3 = useInView(ref3);

  return (
    <Layout>
      <div className="flex justify-center items-center pt-8 pl-4 pr-4 pb-8 sm:p-16 md:p-24 md:pl-10 md:pr-8 md:pt-20 lg:pl-24 lg:pr-24 animate__animated animate__fadeIn z-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-12 items-stretch max-w-5xl mx-auto">
          {/* Left Container */}
          <div className="flex flex-col justify-center items-center md:items-start text-center md:text-left bg-white p-6 gap-8 lg:gap-10">
            <img
              className="h-20 w-20 md:h-16 md:w-16 rounded-full"
              src={myimage}
              alt="profile"
            />

            <div className="flex flex-col">
              <p className="text-4xl xs:text-5xl xl:text-6xl font-normal leading-snug xs:leading-snug md:leading:normal xl:leading-normal">
                Hello!
              </p>

              <p className="text-4xl xs:text-5xl xl:text-6xl font-normal leading-snug xs:leading-snug md:leading-normal xl:leading-normal">
                I’m Prabhav Dev
              </p>
            </div>

            <div className="flex items-center justify-center gap-4 md:gap-2 lg:gap-4">
              {/* Sumly button for < lg screens */}
              <Link to="/sumly" className="block mr-0 md:mr-3 lg:hidden">
                <button className="py-2 px-4 sumly-gradient-border text-lg font-medium block rounded-xl">
                  Sumly
                </button>
              </Link>
              {/* Work Experience button for lg+ screens */}
              <a href="#work_experience" className="hidden lg:block">
                <button className="hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                  Work Experience
                </button>
              </a>

              <div
                className="flex relative"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <button className="hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                  Tech Stack
                </button>

                {isHovered && (
                  <div className="absolute bottom-full right-0 mb-2 p-4 w-64 sm:w-80 text-sm bg-white border border-gray-300 rounded-xl shadow-lg flex flex-col text-start gap-2 animate__animated animate__zoomIn">
                    <p>
                      <strong>Core: </strong>Product Strategy & Growth, Problem
                      Solving, Application & System Development, Research &
                      Analysis, Technical Writing, Content Creation, AI-Assisted
                      Development & Automation
                    </p>

                    <p>
                      <strong>Tech & Tools: </strong>Claude, Cursor AI, ChatGPT,
                      Gemini, Perplexity, React.js, Tailwind CSS, WordPress,
                      PHP, APIs, Git, GitHub, Figma, JIRA, Postman, Notion,
                      Excel, Word, Google Docs, LaTeX, Overleaf, Azure,
                      Diagramming, and <b>other AI tools as needed</b>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Container */}
          <div className="flex flex-col justify-center md:justify-start items-center md:items-start text-center md:text-left bg-white p-6 gap-8">
            <p className="font-normal xs:leading-snug text-3xl xs:text-4xl">
              I like figuring things out.
            </p>
            <p className="text-base md:text-md text-gray-500 xs:leading-relaxed">
              Whether it’s building a product, solving a tricky problem,
              researching something new, or using AI to turn an idea into
              reality — I’ll find a way to get it done. I’m curious, hands-on,
              quick to learn, and always ready to pick up whatever the problem
              demands.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/me_life">
                <button className="bg-black hover:bg-white hover:text-black text-white font-normal text-md py-3 px-4 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                  Highlights
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className="flex justify-center items-center pt-16 pl-6 pr-6 pb-8 sm:p-16 md:p-24 md:pl-12 md:pr-12 md:pt-20 lg:pl-24 lg:pr-24 lg:pt-24 bg-gray-50"
        id="work_experience"
      >
        <div className="grid grid-cols-1 gap-16 md:gap-20 items-stretch max-w-6xl mx-auto">
          <div className="text-3xl">Work Experience</div>

          <div
            className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 p-8 md:p-11 bg-white hover:shadow-md rounded-2xl"
            ref={ref3}
          >
            <div className="flex flex-col space-y-6">
              <div className="flex flex-col">
                <p className="text-xl font-normal text-black">
                  Associate Software Engineer -
                  <a
                    href="https://www.linkedin.com/company/accuknox/"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline text-blue-700"
                  >
                    {" "}
                    AccuKnox
                  </a>
                </p>
                <div className="flex flex-col mt-3">
                  <div className="flex justify-start items-center">
                    <p className="text-gray-500 text-xs">July 2025 - Present</p>
                  </div>
                  <div>
                    <a
                      href={Star_Performer}
                      download="Star_Performer.jpg"
                      className="hover:underline text-md font-semibold text-blue-700"
                    >
                      Star Performer
                    </a>
                  </div>
                </div>
              </div>

              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView3 ? "animate-fadeInUpShort" : ""
                }`}
              >
                <div className="flex flex-col gap-2">
                  <p className="text-gray-700 text-md">
                    <b>Centralized Cloud Security Data Collection</b>—
                    Identified an opportunity to improve cloud security data
                    visibility and drove the development of a centralized
                    ecosystem with multi-tool integrations, automated workflows,
                    and a self-serve onboarding experience.
                  </p>
                </div>
              </div>

              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView3 ? "animate-fadeInUpShort" : ""
                }`}
              >
                <div className="flex flex-col gap-2">
                  <p className="text-gray-700 text-md">
                    <b>Third-Party Integration Ecosystem</b> — Led the
                    improvement of integrations across ticketing, messaging, and
                    other platforms by expanding connectors, introducing new
                    capabilities, and simplifying the overall user experience.
                  </p>
                </div>
              </div>

              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView3 ? "animate-fadeInUpMedium" : ""
                }`}
              >
                <div className="flex flex-col gap-2">
                  <p className="text-gray-700 text-md">
                    <b>AI Gateway</b> — Drove the development of a secure,
                    model-agnostic gateway for LLM interactions, enabling
                    customers to use self-hosted or cloud-hosted models with
                    centralized prompt-firewall protection.
                  </p>
                </div>
              </div>

              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView3 ? "animate-fadeInUpMedium" : ""
                }`}
              >
                <div className="flex flex-col gap-2">
                  <p className="text-gray-700 text-md">
                    <b>ASK AI Evolution</b> — Helped transform ASK AI from a
                    standalone feature into a scalable AI-powered query system
                    by driving new capabilities and continuously improving
                    functionality, reliability, and user experience.
                  </p>
                </div>
              </div>
            </div>

            <div
              className={`flex justify-center items-center ${
                isInView3 ? "animate-fadeInFormView" : ""
              }`}
            >
              <a href="https://accuknox.com/" target="_blank" rel="noreferrer">
                <img
                  src={accuknox}
                  alt="Accuknox"
                  className="w-full h-auto rounded-xl border border-gray-200"
                />
              </a>
            </div>
          </div>

          <div
            className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 p-8 md:p-12 bg-white hover:shadow-md rounded-2xl"
            ref={ref1}
          >
            <div className="flex flex-col space-y-6">
              <div className="flex items-center space-x-3">
                <p className="text-xl font-normal text-black">
                  SDE Intern -
                  <a
                    href="https://www.linkedin.com/company/springrole/"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline text-blue-700"
                  >
                    {" "}
                    Springworks
                  </a>
                </p>
              </div>
              <div className="flex flex-col space-y-1">
                <div className="flex items-center space-x-2">
                  Toro Horizon 360 | Trivia
                </div>
                <p className="text-gray-500 text-xs">
                  September 2023 - June 2024
                </p>
              </div>

              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView1 ? "animate-fadeInUpShort" : ""
                }`}
              >
                <p className="text-gray-700 text-md">
                  <b>Employee Engagement Platform</b> — Helped evolve a
                  team-building platform focused on strengthening workplace
                  connections, contributing to new interactive experiences
                  across web, Slack, and Microsoft Teams.
                </p>
              </div>
              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView1 ? "animate-fadeInUpShort" : ""
                }`}
              >
                <p className="text-gray-700 text-md">
                  <b>Trivia Product Experience</b> — Took ownership of key parts
                  of the product experience, turning product requirements and
                  designs into responsive, intuitive experiences across devices
                  and user touchpoints.
                </p>
              </div>
              <div
                className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                  isInView1 ? "animate-fadeInUpShort" : ""
                }`}
              >
                <p className="text-gray-700 text-md">
                  <b>Toro Horizon 360</b> — Contributed to a business platform
                  used by international clients, working across customer and
                  equipment management, scheduling, dispatching, time tracking,
                  and route optimization.
                </p>
              </div>
            </div>

            <div
              className={`flex justify-center items-center  ${
                isInView1 ? "animate-fadeInFormView" : ""
              }`}
            >
              <img
                src={toro_image}
                alt="Toro Horizon 360"
                className="w-full h-auto rounded-xl border border-gray-200"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-gray-50">
        <div className="grid grid-cols-1 items-stretch max-w-5xl mx-auto">
          <p className="text-3xl xs:text-4xl md:text-5xl text-center leading-normal xs:leading-normal md:leading-normal">
            From a blank page to a working solution, I enjoy figuring out the
            way forward.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default MeWork;
